import { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"

import { isPayingUserSelector, userAtom } from "@/atoms/userAtom"
import { useOrg } from "@/hooks/useOrg"
import { IPreference } from "@/types/organizations.types"
import { SecondaryText, SemiBoldLabelText } from "@/UI"
import { Input } from "antd"
import { AnimatePresence, motion } from "framer-motion"
import KosmoButton from "@/UI/Buttons/KosmoButton"
import React from "react"

interface IPreparationSettingsProps {}

const PreparationSettings: React.FC<IPreparationSettingsProps> = () => {
  const { t } = useTranslation()
  const user = useRecoilValue(userAtom)
  const isPayingUser = useRecoilValue(isPayingUserSelector)
  const { updateOrgPreferences, isLoading } = useOrg()
  const [preparationTime, setPreparationTime] = useState<number>()

  const handleUpdate = async () => {
    await updateOrgPreferences({
      ...user.preference,
      preparationTime: (preparationTime || 0) * 60,
    } as IPreference)
  }

  useEffect(() => {
    setPreparationTime(user.preference?.preparationTime ? user.preference?.preparationTime / 60 : 0)
  }, [user.preference])

  const isFormDirty = (preparationTime || 0) * 60 !== user?.preference?.preparationTime

  return (
    <>
      <div className="flex w-full">
        <div className="w-full">
          <AnimatePresence>
            <div className="flex flex-col space-y-3">
              <motion.div
                className="rounded-md bg-gray-50 px-4 overflow-hidden"
                initial={{
                  maxHeight: 0,
                  opacity: 0,
                  x: 30,
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
                animate={{
                  maxHeight: "150px",
                  opacity: 1,
                  x: 0,
                  paddingTop: 12,
                  paddingBottom: 12,
                }}
                exit={{
                  maxHeight: 0,
                  opacity: 0,
                  x: 30,
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
              >
                <SecondaryText>
                  {t("profile.DispatchSettings.preparationSettingsDesc")}
                </SecondaryText>
              </motion.div>
              <div className="flex flex-col">
                <SemiBoldLabelText>
                  {t("profile.DispatchSettings.preparationTime")}
                </SemiBoldLabelText>
                <div className="flex space-x-3">
                  <Input
                    prefix=" "
                    className="withAddOnInput !max-w-[150px]"
                    placeholder={"15"}
                    value={preparationTime}
                    type="number"
                    onChange={(e) => setPreparationTime(Number(e.target.value))}
                    addonAfter="Minutes"
                    style={{ borderRadius: "none !important" }}
                    disabled={!isPayingUser}
                  />
                </div>
              </div>
              <div className="flex">
                {isFormDirty && (
                  <KosmoButton onClick={handleUpdate} isDisabled={isLoading || !isPayingUser}>
                    {t("common.save")}
                  </KosmoButton>
                )}
              </div>
            </div>
          </AnimatePresence>
        </div>
      </div>
    </>
  )
}

export default PreparationSettings
